import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { OverlayChildren } from 'react-bootstrap/Overlay';

interface Props {
    name: string
}

export const Property: React.FC<Props> = ({name}) => {
    const ref = useRef<HTMLSpanElement | null>(null);

    const [hasEllipsis, setHasEllipsis] = useState<boolean>(false);

    const elementHasEllipsis = (element: HTMLSpanElement): boolean => {
        return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
    }

    useEffect(() => {
        setHasEllipsis(elementHasEllipsis(ref.current as HTMLSpanElement));
    }, [ref]);


    if (hasEllipsis) {
        const renderTooltip: OverlayChildren = (props) => (
            <Tooltip id="button-tooltip" {...props}>
                {name}
            </Tooltip>
        );

        return (
            <OverlayTrigger
                placement="right"
                delay={{ show: 800, hide: 500 }}
                overlay={renderTooltip}
            >
                <span className={classNames("property-select-popover__name")} ref={ref}>{name}</span>
            </OverlayTrigger>
        );
    }

    return (
        <span className={classNames("property-select-popover__name")} ref={ref}>{name}</span>
    );
}
